// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"f6dd9871","223":"fd17319a","499":"6bd3e733"}[chunkId] + ".chunk.js";
};